import { useAppDispatch, useAppSelector } from '@hooks/useRedux';
import { exchangeBankPublicTokenAction } from '@redux/actions/banks';
import { IRootState } from '@redux/configureStore';
import { useEffect } from 'react';
import { usePlaidLink } from 'react-plaid-link';

const OAuthReturnPage = () => {
    const dispatch = useAppDispatch();

    const { link_token, } = useAppSelector(
        (state: IRootState) => ({
            link_token: state.banks.link_token
        })
    );

    useEffect(() => {
        if (!link_token) return;

        const { open, ready } = usePlaidLink({
            token: link_token,
            receivedRedirectUri: window.location.href,
            onSuccess: (public_token) => {
                dispatch(exchangeBankPublicTokenAction(public_token));
            },
        });

        if (ready) {
            open();
        }
    }, [link_token, dispatch]);
    return (
        <div>OAuthReturnPage</div>
    )
}

export default OAuthReturnPage